<template>
  <div class="date-picker">
    <date-picker
      type="datetime"
      :confirm="true"
      :clearable="false"
      :editable="false"
      :confirm-text="confirmText"
      :placeholder="placeholder"
      :value="value"
      :disabled-date="disableBeforeToday"
      :disabled-time="disablePastTimes"
      :append-to-body="appendToBody"
      format="YYYY-MM-DD HH:mm"
      @change="handleChange"
    />
  </div>
</template>
 
<script>
import addDays from 'date-fns/addDays';
import DatePicker from 'vue2-datepicker';
 
export default {
  components: { DatePicker },
  props: {
    confirmText: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: Date,
      default: null,
    },
    appendToBody: {
      type: Boolean,
      default: false,
    },
  },
 
  methods: {
    handleChange(value) {
      this.$emit('change', value);
    },

    disableBeforeToday(date) {
      const yesterdayDate = addDays(new Date(), -1);
      return date < yesterdayDate;
    },
 
    disablePastTimes(date) {
      const now = new Date();
      const minTime = new Date(now.getTime() + 4 * 60 * 1000);
      
      const isToday =
        date.getFullYear() === now.getFullYear() &&
        date.getMonth() === now.getMonth() &&
        date.getDate() === now.getDate();
 
      if (!isToday) {
        return false; 
      }
 
      const minHour = minTime.getHours();
      const minMinute = minTime.getMinutes();
 
      const evaluatedHour = date.getHours();
      const evaluatedMinute = date.getMinutes();
 
      if (evaluatedHour < minHour) {
        return true; 
      } else if (evaluatedHour === minHour && evaluatedMinute < minMinute) {
        return true; 
      }
 
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.date-picker {
  position: relative;

  /* Open picker only from the input row, not the full-width datepicker container */
  ::v-deep .mx-datepicker {
    position: relative;
    width: 100%;
    pointer-events: none;
  }

  ::v-deep .mx-input-wrapper,
  ::v-deep .mx-input {
    pointer-events: auto;
  }

  ::v-deep .mx-datepicker-popup {
    z-index: 100 !important;
    position: absolute !important;
    pointer-events: auto;
  }

  ::v-deep .mx-calendar-content {
    z-index: 100 !important;
  }

  ::v-deep .mx-calendar-time {
    z-index: 100 !important;
  }
}
</style>